import React from 'react';
import ButtonBase from './ButtonBase';
import { ButtonProps } from './Button.types';

const Button: React.FC<ButtonProps> = ({ ...props }) => {
  return <ButtonBase as="button" {...props} />;
};

export default Button;
